import { PlayEventTypes } from '../PlayEvents';
import moundVisitHelper from '@gameday/utils/moundVisitHelper';

const {
    ACTION,
    PICKOFF,
    STEPOFF,
    BATTER_TIMEOUT,
    MOUND_VISIT
} = PlayEventTypes;

const summaryHiddenEventTypes =  new Set([BATTER_TIMEOUT, MOUND_VISIT]);
const liveFeedHiddenEventTypes = new Set([ PICKOFF, STEPOFF, BATTER_TIMEOUT]);
const hideTitleEventTypes =  new Set([PICKOFF, STEPOFF, BATTER_TIMEOUT, MOUND_VISIT]);

export const determineChipFeedEventDisplay = (event = {}) => {
    const {type} = event;
    return (type === ACTION || type === PICKOFF || type === STEPOFF);
};

export const determineLiveFeedEventDisplay = (event = {}, isCurrentPlay) => {
    const {
        details: {    
            eventType
        } = {},
        type
    } = event;
    const hideEvent = !isCurrentPlay && (liveFeedHiddenEventTypes.has(eventType) || liveFeedHiddenEventTypes.has(type));
    return !hideEvent && (type === ACTION || type === PICKOFF || type === STEPOFF);
};

export const determineSummaryEventDisplay = (filterMap = { all: true }, event = {}, eventFlags = {}, ) => {
    const {
        details: {    
            eventType,
            description,
            event: detailsEvent
        } = {},
        type
    } = event;
    let hideEvent = false;

    if (eventType !== 'game_advisory') {
        hideEvent = summaryHiddenEventTypes.has(eventType) || summaryHiddenEventTypes.has(type);
    } else {
        hideEvent = moundVisitHelper(eventType, description, detailsEvent);
    }

    if (hideEvent) {
        return false
    };

    const {
        all,
        scoringPlays,
        keyMoments,
        leadChange,
        winProb
    } = filterMap;
    const {
        isScoringEvent,
        isKeyMomentEvent,
        isWinProbEvent,
        isLeadChangeEvent,
    } = eventFlags;
    return (all && type === ACTION) ||
        (scoringPlays && isScoringEvent) ||
        (keyMoments && isKeyMomentEvent) ||
        (leadChange && isLeadChangeEvent) ||
        (winProb && isWinProbEvent);
};

export const shouldDisplayTitle = (eventType) => {
    return !hideTitleEventTypes.has(eventType);
}
